import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import {
  ClothingBiometry,
  EmployeeClothingEntitlementsSource,
  EmployeeClothingOverview,
  EmployeeClothingPosition,
  ClothingProfileStorekeeper,
  HeadClothingManualExtensionPayload,
  StorekeeperIssuePayload,
  StorekeeperRejectNoStockPayload
} from '../../../models/clothing.model';
import { ProfileClothingViewItem } from '../../../models/profile-clothing.model';
import { User } from '../../../models/user.model';
import { ClothingService } from '../../../services/clothing.service';
import { ClothingErrorService } from '../../../services/clothing-error.service';
import { ProfileClothingViewService } from '../../../services/profile-clothing-view.service';
import { TimeFormatterService } from '../../../services/time-formatter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeSalaryComponent } from './change-salary/change-salary.component';
import { GetClotheComponent } from '../view-user-profile/get-clothe/get-clothe.component';
import { BiometricsComponent } from './biometrics/biometrics.component';
import { AdminService } from '../../../services/admin.service';
import { GroupResponse, UserInfoBody } from '../../../services/admin.service.types';
import { ChangeExperienceComponent } from './change-experience/change-experience.component';
import { ReportDatepickerComponent } from '../../../modals/report-datepicker.component';
import { ReportType } from '../../../models/report-type.model';
import { ToastService } from '../../../services/toast.service';
import { AppConstants } from './app.constants';
import { UserProfile, ClothesInfo, UserWrapper, GroupWithPosition, ParametersUser } from './view-user-profile.types';
import { ClothingHeadExtensionModalComponent } from '../../../modals/clothing-head-extension-modal.component';
import { ClothingIssueModalComponent } from '../../../modals/clothing-issue-modal.component';

@Component({
  selector: 'app-view-user-profile',
  templateUrl: './view-user-profile.component.html',
  styleUrls: ['./view-user-profile.component.css']
})
export class ViewUserProfileComponent implements OnInit {

  public isLoaded = false;
  public user: UserProfile;
  public notFound = false;
  public request = false;
  public isAdmin = false;
  public isHead = false;
  public isUser = false;
  public isStorekeeper = false;
  public userActive: User;
  public userId: string;
  public wrapperUser: UserWrapper;
  public errorMessage = false;
  public visible = false;
  public infoClothes: ClothesInfo;
  public isCheckTimetablePF: boolean;
  public isCheckTimetable: boolean;
  public ountRecyclingB: boolean;
  public checkId = true;
  public showStorekeeperClothing = false;
  public isStorekeeperClothingLoaded = false;
  public storekeeperClothingError = false;
  public storekeeperClothingItems: ProfileClothingViewItem[] = [];
  public clothingStorekeeper: ClothingProfileStorekeeper;
  public clothingBiometry: ClothingBiometry;
  public showHeadClothing = false;
  public isHeadClothingLoaded = false;
  public headClothingError = false;
  public headClothingItems: ProfileClothingViewItem[] = [];

  private selectMainGroupId: string;
  private currentUserMainGroupId: string;
  private groupList: GroupWithPosition[];
  private groupForUser: GroupResponse[];
  private issueActionKey = '';
  private rejectRequestId = '';
  private extendPositionId = '';

  constructor(public userService: UserService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private adminService: AdminService,
    private timeFormatter: TimeFormatterService,
    private clothingService: ClothingService,
    private clothingErrorService: ClothingErrorService,
    private profileClothingViewService: ProfileClothingViewService,
    private toastService: ToastService,
    private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.initializeUserRoles();
    this.getUserInfo();
    
    if (this.isHead || this.isAdmin) {
      this.checkClothes();
      this.loadUserData();
    }
  }

  private initializeUserRoles(): void {
    this.userActive = this.userService.getLocal();
    this.isAdmin = this.userActive.roles.includes(AppConstants.ROLES.ADMIN);
    this.isHead = this.userActive.roles.includes(AppConstants.ROLES.HEAD);
    this.isUser = this.userActive.roles.includes(AppConstants.ROLES.USER);
    this.isStorekeeper = this.userActive.roles.includes(AppConstants.ROLES.STOREKEEPER)
      || this.userActive.roles.includes('STOREKEEPER');
  }

  trackByClothingItem(index: number, item: ProfileClothingViewItem): string {
    return item.catalogItemId;
  }

  trackByRole(index: number, role: string): string {
    return role;
  }

  showClothingPanel(): boolean {
    return this.showStorekeeperClothing || this.showHeadClothing;
  }

  getProfileColumnClass(): string {
    if (this.showStorekeeperClothing) {
      return 'col-lg-5 col-md-12';
    }
    if (this.showHeadClothing) {
      return 'col-12';
    }
    return 'col-12';
  }

  getClothingColumnClass(): string {
    if (this.showHeadClothing && !this.showStorekeeperClothing) {
      return 'col-12';
    }
    return 'col-lg-7 col-md-12';
  }

  getClothingHintKey(): string {
    if (this.showStorekeeperClothing) {
      return 'CLOTHING_STOREKEEPER_PROFILE_HINT';
    }
    return 'CLOTHING_HEAD_PROFILE_HINT';
  }

  showStorekeeperContact(): boolean {
    if (this.showHeadClothing && !this.showStorekeeperClothing) {
      return false;
    }
    return !!this.clothingStorekeeper && !!this.clothingStorekeeper.userId;
  }

  showStorekeeperBiometry(): boolean {
    return this.showStorekeeperClothing && !!this.clothingBiometry;
  }

  formatBiometryValue(value: number): string {
    if (typeof value !== 'number') {
      return '-';
    }
    return String(value);
  }

  showMobileProfile(): boolean {
    return !!this.user && !this.notFound;
  }

  showStorekeeperMobileProfile(): boolean {
    return this.showMobileProfile();
  }

  getStorekeeperProfileInitials(): string {
    if (!this.user) {
      return '';
    }
    var lastInitial = this.user.lastName ? this.user.lastName.charAt(0) : '';
    var firstInitial = this.user.firstName ? this.user.firstName.charAt(0) : '';
    var initials = (lastInitial + firstInitial).toUpperCase();
    return initials || '?';
  }

  getStorekeeperBiometryValue(field: string): string {
    var value = this.getClothingBiometryField(this.clothingBiometry, field);

    if (!this.hasProfileMetricValue(value)) {
      value = this.user && this.user.parametersUser
        ? this.getProfileBiometryField(this.user.parametersUser, field)
        : null;
    }

    if (!this.hasProfileMetricValue(value)) {
      return '-';
    }
    return String(value);
  }

  isClothingPanelLoaded(): boolean {
    if (this.showStorekeeperClothing) {
      return this.isStorekeeperClothingLoaded;
    }
    return this.isHeadClothingLoaded;
  }

  hasClothingPanelError(): boolean {
    if (this.showStorekeeperClothing) {
      return this.storekeeperClothingError;
    }
    return this.headClothingError;
  }

  getClothingItems(): ProfileClothingViewItem[] {
    if (this.showStorekeeperClothing) {
      return this.storekeeperClothingItems;
    }
    return this.headClothingItems;
  }

  hasClothingActions(item: ProfileClothingViewItem): boolean {
    if (this.showStorekeeperClothing) {
      return this.hasStorekeeperActions(item);
    }
    return this.showHeadClothing && item.canHeadExtend;
  }

  hasStorekeeperActions(item: ProfileClothingViewItem): boolean {
    return this.showStorekeeperClothing;
  }

  showIssueAction(item: ProfileClothingViewItem): boolean {
    return this.showStorekeeperClothing;
  }

  isIssuePending(item: ProfileClothingViewItem): boolean {
    return this.issueActionKey === this.createIssueActionKey(item);
  }

  isHeadExtendPending(item: ProfileClothingViewItem): boolean {
    return !!item.positionId && this.extendPositionId === item.positionId;
  }

  isRejectPending(item: ProfileClothingViewItem): boolean {
    return !!item.requestId && this.rejectRequestId === item.requestId;
  }

  getLifeWidth(item: ProfileClothingViewItem): string {
    return item.lifePercent + '%';
  }

  issueStorekeeperItem(item: ProfileClothingViewItem): void {
    if (item.issueDisabled || this.isIssuePending(item)) {
      return;
    }
    this.openIssueModal(item);
  }

  rejectStorekeeperRequest(item: ProfileClothingViewItem): void {
    if (item.rejectDisabled || this.isRejectPending(item)) {
      return;
    }
    this.rejectRequestId = item.requestId;
    this.clothingService.rejectStorekeeperRequest(
      item.requestId,
      this.createRejectPayload()
    ).subscribe(
      () => this.handleRejectSuccess(),
      (error) => this.handleRejectError(error)
    );
  }

  open(): void {
    const modalRef = this.modalService.open(ReportDatepickerComponent);
    modalRef.componentInstance.reportType = ReportType.BY_PROFILE;
    modalRef.componentInstance.userId = this.route.snapshot.params['id'];
    modalRef.result.then((result) => {
      if (result) {
        this.user.dateOfEmployment = result;
      }
    });
  }

  private getList(response: HttpResponse<UserProfile>, user: UserProfile): void {
    const currentUserId = this.userService.getLocal().id;
    this.adminService.getMyGroups(currentUserId).subscribe(
      (res: HttpResponse<GroupResponse[]>) => {
        this.groupForUser = res.body;
        this.checkVisible(response, user, this.groupForUser);
      }
    );
  }

  private getClothingBiometryField(source: ClothingBiometry, field: string): any {
    if (!source) {
      return null;
    }
    switch (field) {
      case 'growth':
        return source.growth;
      case 'weight':
        return source.weight;
      case 'clothingSize':
        return source.clothingSize;
      case 'shoeSize':
        return source.shoeSize;
      default:
        return null;
    }
  }

  private getProfileBiometryField(source: ParametersUser, field: string): any {
    if (!source) {
      return null;
    }
    switch (field) {
      case 'growth':
        return source.growth;
      case 'weight':
        return source.weight;
      case 'clothingSize':
        return source.clothingSize;
      case 'shoeSize':
        return source.shoeSize;
      default:
        return null;
    }
  }

  private hasProfileMetricValue(value: any): boolean {
    return value !== null && typeof value !== 'undefined' && value !== '';
  }

  postiruem(tumbler: boolean): void {
    this.adminService.postiruem(this.user.id, tumbler).subscribe(
      () => this.loadUserData()
    );
  }

  postiruemOvertime(tumbler: boolean): void {
    this.adminService.postiruemOver(this.user.id, tumbler).subscribe(
      () => this.loadUserData()
    );
  }

  private loadUserData(): void {
    const userId = this.getUserId();
    const apiCall = this.getUserApiCall(userId);
    
    apiCall.subscribe(
      (response: HttpResponse<UserProfile>) => {
        if (response.status === AppConstants.HTTP_STATUS.OK) {
          this.updateUserSettings(response.body);
          this.loadGroupList();
        }
      }
    );
  }

  private updateUserSettings(userData: UserProfile): void {
    this.user = userData;
    this.isCheckTimetablePF = userData.payrollMethod;
    this.isCheckTimetable = userData.checkTimetable;
    this.ountRecyclingB = userData.acceptOvertime;
  }

  changeTime(status: string): void {
    const isOn = status === 'ON';
    this.isCheckTimetable = isOn;
    this.submit(isOn);
  }

  private loadGroupList(): void {
    this.adminService.getUserInfo(this.user.id).subscribe(
      (response: HttpResponse<UserInfoBody>) => {
        this.groupList = response.body.groupsWithPositions;
      }
    );
  }

  private submit(checkTimetable: boolean): void {
    this.user.checkTimetable = checkTimetable;
    this.wrapperUser = {
      user: this.user,
      groupsWithPositions: this.groupList
    };
    this.adminService.updateUser(this.wrapperUser).subscribe();
  }

  private getUserInfo(): void {
    const userId = this.getUserId();
    const apiCall = this.getUserApiCall(userId);
    
    apiCall.subscribe(
      (response: HttpResponse<UserProfile>) => this.handleUserInfoResponse(response),
      () => this.errorMessage = true
    );
  }

  private getUserId(): string {
    return this.route.snapshot.params['id'];
  }

  private getUserApiCall(userId: string) {
    return this.userService.getUserFromAPI(userId);
  }

  private handleUserInfoResponse(response: HttpResponse<UserProfile>): void {
    this.errorMessage = false;
    this.userId = this.getUserId();
    this.user = response.body;
    this.isLoaded = true;

    switch (response.status) {
      case AppConstants.HTTP_STATUS.OK:
        this.handleSuccessResponse(response);
        break;
      case AppConstants.HTTP_STATUS.NO_CONTENT:
        this.setUserState(true, false);
        break;
      case AppConstants.HTTP_STATUS.PRECONDITION_FAILED:
        this.setUserState(false, true);
        break;
    }
  }

  private handleSuccessResponse(response: HttpResponse<UserProfile>): void {
    this.loadHeadVisibility(response);
    this.checkId = this.userId === this.userActive.id ? this.isAdmin : true;
    this.loadHeadClothing();
    this.loadStorekeeperClothing();
    this.setUserState(false, false);
  }

  private loadHeadVisibility(response: HttpResponse<UserProfile>): void {
    if (!this.isHead && !this.isAdmin) {
      return;
    }
    this.getList(response, this.user);
  }

  private checkClothes(): void {
    this.userService.getClothes(this.route.snapshot.params['id']).subscribe(
      (response: HttpResponse<ClothesInfo>) => {
        this.infoClothes = response.body;
        const status = this.infoClothes.clothesStatus;
        if (AppConstants.CLOTHES_STATUS[status]) {
          this.infoClothes.clothesStatus = AppConstants.CLOTHES_STATUS[status];
        }
      },
      () => {
        this.infoClothes = null;
      }
    );
  }

  biometrics(): void {
    this.openModal(BiometricsComponent, (modal) => {
      if (this.user.parametersUser) {
        modal.componentInstance.setValue(this.user.parametersUser);
      }
    }, () => this.getUserInfo());
  }

  openEditPos(): void {
    this.openModal(ChangeSalaryComponent, (modal) => {
      modal.componentInstance.setValue(this.user.salary);
    }, () => this.getUserInfo());
  }

  openClothes(): void {
    this.openModal(GetClotheComponent, null, () => this.checkClothes());
  }

  private openModal(component: any, configure?: (modal: any) => void, onSuccess?: () => void): void {
    const modalRef = this.modalService.open(component);
    modalRef.componentInstance.setId(this.user.id);
    
    if (configure) {
      configure(modalRef);
    }

    modalRef.result.then((result) => {
      if (result === AppConstants.MODAL_RESULT.OK && onSuccess) {
        onSuccess();
      }
    });
  }

  private checkVisible(response: HttpResponse<UserProfile>, user: UserProfile, groups: GroupResponse[]): void {
    this.selectMainGroupId = response.body.mainGroup;
    const currentUserId = this.userService.getLocal().id;
    const currentUserMainGroup = this.userService.getLocal().mainGroup;
    
    let matchingGroupId: string;
    groups.forEach(element => {
      if (element && element.head && element.head.id === currentUserId && element.id === this.selectMainGroupId) {
        matchingGroupId = element.id;
      }
    });
    
    this.currentUserMainGroupId = currentUserMainGroup;
    const isMainGroupMatch = this.selectMainGroupId === user.mainGroup;
    const isHeadOrSelf = matchingGroupId === this.selectMainGroupId || this.route.snapshot.params['id'] === currentUserId;
    this.visible = isMainGroupMatch && isHeadOrSelf;
  }

  private setUserState(notFound: boolean, request: boolean): void {
  this.notFound = notFound;
  this.request = request;
  }

  private loadStorekeeperClothing(): void {
    if (!this.isStorekeeper) {
      return;
    }
    this.isStorekeeperClothingLoaded = false;
    this.storekeeperClothingError = false;
    Observable.forkJoin(
      this.clothingService.getStorekeeperEmployeeOverview(this.userId),
      this.clothingService.getStorekeeperEmployeeEntitlements(this.userId)
    ).subscribe(
      (response) => this.handleStorekeeperOverviewSuccess(response),
      (error) => this.handleStorekeeperClothingError(error)
    );
  }

  private handleStorekeeperOverviewSuccess(response: Object[]): void {
    var overview = response[0] as EmployeeClothingOverview;
    var entitlements = response[1] as EmployeeClothingEntitlementsSource;
    var items = this.profileClothingViewService.mapStorekeeperOverview(
      overview,
      entitlements
    );
    this.handleStorekeeperClothingSuccess(
      overview,
      items,
      this.resolveStorekeeperBiometry(overview, entitlements)
    );
  }

  private handleStorekeeperClothingSuccess(
    overview: EmployeeClothingOverview,
    items: ProfileClothingViewItem[],
    biometry: ClothingBiometry
  ): void {
    this.storekeeperClothingItems = items;
    this.clothingStorekeeper = this.resolveClothingStorekeeper(overview);
    this.clothingBiometry = biometry;
    this.isStorekeeperClothingLoaded = true;
    this.storekeeperClothingError = false;
    this.showStorekeeperClothing = this.hasClothingItems(items);
    this.clearStorekeeperPendingActions();
  }

  private handleStorekeeperClothingError(error: HttpErrorResponse): void {
    this.storekeeperClothingItems = [];
    this.clothingStorekeeper = null;
    this.clothingBiometry = null;
    this.isStorekeeperClothingLoaded = true;
    this.clearStorekeeperPendingActions();
    if (error && error.status === 403) {
      this.showStorekeeperClothing = false;
      this.storekeeperClothingError = false;
      return;
    }
    this.showStorekeeperClothing = true;
      this.storekeeperClothingError = true;
  }

  private loadHeadClothing(): void {
    if (!this.isHead || this.isStorekeeper) {
      return;
    }
    this.isHeadClothingLoaded = false;
    this.headClothingError = false;
    this.clothingService.getHeadEmployeePositions(this.userId).subscribe(
      (positions) => this.handleHeadClothingSuccess(
        this.profileClothingViewService.mapHeadPositions(positions as EmployeeClothingPosition[])
      ),
      (error) => this.handleHeadClothingError(error)
    );
  }

  extendHeadPosition(item: ProfileClothingViewItem): void {
    if (item.headExtendDisabled || this.isHeadExtendPending(item)) {
      return;
    }
    this.openHeadExtensionModal(item);
  }

  private handleHeadClothingSuccess(items: ProfileClothingViewItem[]): void {
    this.headClothingItems = items;
    this.clothingStorekeeper = null;
    this.clothingBiometry = null;
    this.isHeadClothingLoaded = true;
    this.headClothingError = false;
    this.showHeadClothing = this.hasClothingItems(items);
    this.extendPositionId = '';
  }

  private handleHeadClothingError(error: HttpErrorResponse): void {
    this.headClothingItems = [];
    this.clothingStorekeeper = null;
    this.clothingBiometry = null;
    this.isHeadClothingLoaded = true;
    this.extendPositionId = '';
    if (error && error.status === 403) {
      this.showHeadClothing = false;
      this.headClothingError = false;
      return;
    }
    this.showHeadClothing = true;
    this.headClothingError = true;
  }

  private createRejectPayload(): StorekeeperRejectNoStockPayload {
    return {
      description: ''
    };
  }

  private handleIssueSuccess(): void {
    this.toastService.success(this.translate.instant('CLOTHING_ISSUE_SUCCESS'));
    this.loadStorekeeperClothing();
  }

  private handleRejectSuccess(): void {
    this.toastService.success(this.translate.instant('CLOTHING_REJECT_SUCCESS'));
    this.loadStorekeeperClothing();
  }

  private handleHeadExtensionSuccess(): void {
    this.toastService.success(this.translate.instant('CLOTHING_EXTENSION_SUCCESS'));
    this.loadHeadClothing();
  }

  private handleIssueError(error: HttpErrorResponse): void {
    this.issueActionKey = '';
    this.toastService.error(this.resolveErrorMessage(error, 'CLOTHING_ISSUE_ERROR'));
  }

  private handleRejectError(error: HttpErrorResponse): void {
    this.rejectRequestId = '';
    this.toastService.error(this.resolveErrorMessage(error, 'CLOTHING_REJECT_ERROR'));
  }

  private handleHeadExtensionError(error: HttpErrorResponse): void {
    this.extendPositionId = '';
    this.toastService.error(this.resolveErrorMessage(error, 'CLOTHING_EXTENSION_ERROR'));
  }

  private resolveErrorMessage(error: HttpErrorResponse, fallbackKey: string): string {
    return this.clothingErrorService.resolveMessage(error, fallbackKey);
  }

  private clearStorekeeperPendingActions(): void {
    this.issueActionKey = '';
    this.rejectRequestId = '';
  }

  private hasClothingItems(items: ProfileClothingViewItem[]): boolean {
    return !!items && !!items.length;
  }

  private resolveClothingStorekeeper(
    overview: EmployeeClothingOverview
  ): ClothingProfileStorekeeper {
    if (!overview || !overview.storekeeper || !overview.storekeeper.userId) {
      return null;
    }
    return overview.storekeeper;
  }

  private resolveClothingBiometry(overview: EmployeeClothingOverview): ClothingBiometry {
    if (!overview || !overview.biometry) {
      return null;
    }
    return overview.biometry;
  }

  private resolveStorekeeperBiometry(
    overview: EmployeeClothingOverview,
    entitlementsSource: EmployeeClothingEntitlementsSource
  ): ClothingBiometry {
    var overviewBiometry = this.resolveClothingBiometry(overview);

    if (overviewBiometry) {
      return overviewBiometry;
    }
    if (!entitlementsSource || Array.isArray(entitlementsSource)) {
      return null;
    }
    return entitlementsSource.biometry || null;
  }

  private issueStorekeeperItemByMode(
    item: ProfileClothingViewItem,
    payload: StorekeeperIssuePayload
  ): void {
    if (item.issueByRequest) {
      this.issueStorekeeperRequest(item, payload);
      return;
    }
    this.directIssueStorekeeperItem(item, payload);
  }

  private issueStorekeeperRequest(
    item: ProfileClothingViewItem,
    payload: StorekeeperIssuePayload
  ): void {
    this.clothingService.issueStorekeeperRequest(
      item.requestId,
      payload
    ).subscribe(
      () => this.handleIssueSuccess(),
      (error) => this.handleIssueError(error)
    );
  }

  private directIssueStorekeeperItem(
    item: ProfileClothingViewItem,
    payload: StorekeeperIssuePayload
  ): void {
    this.clothingService.directIssueStorekeeperItem(
      this.userId,
      item.catalogItemId,
      payload
    ).subscribe(
      () => this.handleIssueSuccess(),
      (error) => this.handleIssueError(error)
    );
  }

  private createIssueActionKey(item: ProfileClothingViewItem): string {
    if (item.requestId) {
      return item.requestId;
    }
    return item.catalogItemId;
  }

  private openIssueModal(item: ProfileClothingViewItem): void {
    var modalRef = this.modalService.open(ClothingIssueModalComponent);
    modalRef.componentInstance.setValues(item.name, item.issueQuantity);
    modalRef.result.then(
      (payload) => this.submitStorekeeperIssue(item, payload),
      () => null
    );
  }

  private submitStorekeeperIssue(
    item: ProfileClothingViewItem,
    payload: StorekeeperIssuePayload
  ): void {
    if (!payload) {
      return;
    }
    this.issueActionKey = this.createIssueActionKey(item);
    this.issueStorekeeperItemByMode(item, payload);
  }

  private openHeadExtensionModal(item: ProfileClothingViewItem): void {
    var modalRef = this.modalService.open(ClothingHeadExtensionModalComponent);
    modalRef.componentInstance.setValues(item.name);
    modalRef.result.then(
      (payload) => this.submitHeadExtension(item, payload),
      () => null
    );
  }

  private submitHeadExtension(
    item: ProfileClothingViewItem,
    payload: HeadClothingManualExtensionPayload
  ): void {
    if (!payload) {
      return;
    }
    this.extendPositionId = item.positionId;
    this.clothingService.extendHeadPosition(item.positionId, payload).subscribe(
      () => this.handleHeadExtensionSuccess(),
      (error) => this.handleHeadExtensionError(error)
    );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile.component.ts